import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntDirectoryInfoName } from "../../../../../models/directoryInfoName";
import {
  useAddTypesOfAgriculturalCropsMutation,
  useDeleteTypesOfAgriculturalCropsMutation,
  useEditTypesOfAgriculturalCropsMutation
} from "../../../../../redux/api/handBooksApi/chemicalization/typesOfAgriculturalCrops";



const useTypesOfAgriculturalCrops = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation()
  const { confirm } = modal;
  const [addTypesOfAgriculturalCrops] = useAddTypesOfAgriculturalCropsMutation();
  const [editTypesOfAgriculturalCrops] = useEditTypesOfAgriculturalCropsMutation();
  const [deleteTypesOfAgriculturalCrops] = useDeleteTypesOfAgriculturalCropsMutation();

  async function onAddTypesOfAgriculturalCrops(newTypesOfAgriculturalCrops: EntDirectoryInfoName): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await addTypesOfAgriculturalCrops(newTypesOfAgriculturalCrops).then((response: any) => {
		if (response.error !== undefined) {
		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  message.success(t('msg.successAdd'));
		  if(refresh) refresh();
		}
	  }).catch((error:any) => {
		modal.error({ title: t('msg.error'), content: String(error.message) });

	  });
	  return status;
	} catch (error: any) {
	  modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }

  async function onDeleteTypesOfAgriculturalCrops(typesOfAgriculturalCrops: EntDirectoryInfoName) {
	try {
	  let status: boolean = false;
	  confirm({
		centered: true,
		title: t('msg.confirmDeleteText'),
		okText: t('general.yes'),
		cancelText: t('general.no'),
		onOk() {
		  deleteTypesOfAgriculturalCrops(typesOfAgriculturalCrops.id as number).then((response: any) => {
			if (response.error !== undefined && response.error.status === 400) {
			  status = false;
			  throw new Error(response.error.data.message);
			}
			if (response.data.success) {
			  status = true;
			  Modal.success({title: t('msg.successDelete')});
			  if(refresh) refresh();
			}
		  }).catch((error: any) => {
			Modal.error({ title: t('msg.error'), content: String(error.message) });

		  });
		}
	  })
	  return status
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  }

  async function onEditTypesOfAgriculturalCrops(editedTypesOfAgriculturalCrops: EntDirectoryInfoName): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await editTypesOfAgriculturalCrops(editedTypesOfAgriculturalCrops).then((response: any) => {
		if (response.error !== undefined && response.error.status === 400) {
		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  Modal.success({title: t('msg.successEdited')});
		  if(refresh) refresh();
		}
	  }).catch((error: any) => {
		Modal.error({ title: t('msg.error'), content: String(error.message) });
	  });
	  return status;
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  }
  return { onAddTypesOfAgriculturalCrops,onDeleteTypesOfAgriculturalCrops, onEditTypesOfAgriculturalCrops }

}
export { useTypesOfAgriculturalCrops };

